export class AndroidAppStore {
  public static readonly GPLAY: string = 'gplay';

  readonly id: string;
}
